<template>
    <div class="row left-content" v-if="driver && driver.driverLicense">
        <div class="col-12">
            <h1>Driver’s License</h1>
        </div>

        <div class="col-md-12 text-right mb-2">
            <div v-if="!driver.driverLicense.isApproved">
                <button @click="requestNew()" class="btn btn-warning mr-2">Request New ID</button>
                <button @click="approve()" class="btn btn-success">Complete</button>
            </div>
            <div v-else>
                <button @click="disapprove()" class="btn btn-secondary">Reset approvement</button>
            </div>
        </div>
        <div class="col-md-7 p-0">
            <div class="col-12">
                <div class="white-block">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="title mb-3">Original Photo</div>
                                <img v-if="driver.driverLicense && driver.driverLicense.photo" :src="driver.driverLicense.photo" class="img100"/>
                                <p class="value" v-else>- - -</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="white-block">
                    <div class="doted-dd-menu">
                        <b-dropdown class="dropdown dropleft">
                            <div slot="button-content">
                                <i class="fa fa-ellipsis-h"></i>
                            </div>
                            <b-dropdown-item v-if="showStartCheckr" @click.prevent="initiateCheck()">Start background check</b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="title mb-3">Checkr</div>
                                <p><b>SSN:</b> {{ driver.ssn ? driver.ssn : 'not set'}}</p>
                                <ul class="text-left violation-ul" v-if="driver.checkr">
                                    <li><b>Status: </b>
                                        <b-badge variant="success" v-if="driver.checkr.status === 'clear'">{{ driver.checkr.status }}</b-badge>
                                        <b-badge variant="danger" v-else-if="driver.checkr.status === 'consider'">{{ driver.checkr.status }}</b-badge>
                                        <b-badge variant="secondary" v-else>{{ driver.checkr.status }}</b-badge>
                                    </li>
                                    <li><b>Candidate Id: </b>{{ driver.checkr.candidateId }}</li>
                                    <li v-if="driver.checkr.candidateError"><b>Candidate Error: </b>{{ driver.checkr.candidateError }}</li>
                                    <li><b>Report Id: </b>{{ driver.checkr.reportId }}</li>
                                    <li v-if="driver.checkr.reportError"><b>Report Error: </b>{{ driver.checkr.reportError }}</li>
                                    <li v-if="driver.checkr.mvrReportId"><b>MVR Report Id: </b>{{ driver.checkr.mvrReportId }}</li>
                                </ul>
                                <b-alert v-else show variant="secondary">Background check is not initiated yet.</b-alert>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="white-block">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="title mb-3">Change Log</div>
                                <div class="table-responsive">
                                    <table class="table table-borderless log-table">
                                        <thead>
                                        <tr>
                                            <th scope="col">DATE</th>
                                            <th scope="col">USER</th>
                                            <th scope="col">ACTION</th>
                                            <th scope="col">ITEM</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="action in actions" :key="action.id">
                                            <td>
                                                <p class="valtitle">{{ date(action.date) }}</p>
                                                <p class="subtitle">{{ time(action.date) }}</p>
                                            </td>
                                            <td><p class="regtitle">{{ action.admin_name ? action.admin_name : action.driver_name }}</p></td>
                                            <td>
                                                <p class="regtitle">
                                                    <span v-if="action.action === 'Approved' || action.action === 'Approved Field'" class="badge badge-success">o</span>
                                                    <span v-else-if="action.action === 'Edited'" class="badge badge-warning">o</span>
                                                    <span v-else-if="action.action === 'Marked N/A'" class="badge badge-secondary">o</span>
                                                    <span v-else-if="action.action === 'Disapproved Field'" class="badge badge-danger">o</span>
                                                    <span v-else class="badge badge-primary">o</span>
                                                    {{ action.action }}
                                                </p>
                                            </td>
                                            <td>
                                                <p class="subtitle">{{ action.item_title }}</p>
                                                <p class="valtitle">{{ action.item_value }}</p>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-5 p-0">
                <div class="col-12">
                    <div class="white-block plr-0">
                        <div class="container prl-0">
                            <div class="row">
                                <div class="col-12">
                                    <div class="title mb-3">Automated Data Captured</div>
                                    <div class="container">
                                        <dl-approve
                                            field="state"
                                            title="State"
                                            :value="driver.driverLicense.address.state"
                                            :approved="driver.driverLicense.address.isStateApproved"
                                            :id="driver.id"
                                            :options="states"
                                            type="select"
                                        ></dl-approve>
                                        <dl-approve
                                            field="number"
                                            title="License Number"
                                            :value="driver.driverLicense.number"
                                            :approved="driver.driverLicense.isNumberApproved"
                                            :id="driver.id"
                                            type="text"
                                        ></dl-approve>
                                        <dl-approve
                                            field="first"
                                            title="First Name"
                                            :value="driver.driverLicense.name.first"
                                            :approved="driver.driverLicense.name.isFirstApproved"
                                            :id="driver.id"
                                            type="text"
                                        ></dl-approve>
                                        <dl-approve
                                            field="middle"
                                            title="Middle Name"
                                            :value="driver.driverLicense.name.middle"
                                            :approved="driver.driverLicense.name.isMiddleApproved"
                                            :id="driver.id"
                                            type="text"
                                        ></dl-approve>
                                        <dl-approve
                                            field="last"
                                            title="Last Name"
                                            :value="driver.driverLicense.name.last"
                                            :approved="driver.driverLicense.name.isLastApproved"
                                            :id="driver.id"
                                            type="text"
                                        ></dl-approve>
                                        <dl-approve
                                            field="expirationDate"
                                            title="Expiration Date"
                                            :value="driver.driverLicense.expirationDate ? baseDate(driver.driverLicense.expirationDate) : null"
                                            :approved="driver.driverLicense.isExpirationDateApproved"
                                            :id="driver.id"
                                            type="date"
                                        ></dl-approve>
                                        <dl-approve
                                            field="birthDate"
                                            title="Birth Date"
                                            :value="driver.driverLicense.birthDate ? baseDate(driver.driverLicense.birthDate) : null"
                                            :approved="driver.driverLicense.isBirthDateApproved"
                                            :id="driver.id"
                                            type="date"
                                        ></dl-approve>
                                        <dl-approve
                                            field="address"
                                            title="Address"
                                            :value="driver.driverLicense.address.address"
                                            :approved="driver.driverLicense.address.isAddressApproved"
                                            :id="driver.id"
                                            type="text"
                                        ></dl-approve>
                                        <dl-approve
                                            field="city"
                                            title="City"
                                            :value="driver.driverLicense.address.city"
                                            :approved="driver.driverLicense.address.isCityApproved"
                                            :id="driver.id"
                                            type="text"
                                        ></dl-approve>
                                        <dl-approve
                                            field="zip"
                                            title="Zip"
                                            :value="driver.driverLicense.address.zip"
                                            :approved="driver.driverLicense.address.isZipApproved"
                                            :id="driver.id"
                                            type="text"
                                        ></dl-approve>
                                        <dl-approve
                                            field="gender"
                                            title="Gender"
                                            :value="driver.driverLicense.gender"
                                            :approved="driver.driverLicense.isGenderApproved"
                                            :id="driver.id"
                                            :options="{'M': 'Male', 'F': 'Female'}"
                                            type="select"
                                        ></dl-approve>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    <div v-else>
        <b-alert show variant="danger">Driver License is not uploaded</b-alert>
    </div>
</template>

<script>
import DLApprove from "@/components/admin/driver/DLApprove";
import Swal from "sweetalert2";
export default {
    name: "One.vue",
    props: ['id'],
    data() {
        return {
            driver: null,
            actions: [],
            states: []
        }
    },
    components: {
        'dl-approve': DLApprove
    },
    methods: {
        date(date) {
            return window.moment(date).tz('America/New_York').format('dddd, MMMM DD, YYYY');
        },
        time(date) {
            return window.moment(date).tz('America/New_York').format('hh:mm A');
        },
        baseDate(date) {
            return window.moment(date).format('YYYY-MM-DD');
        },
        formatedDate(date) {
            return window.moment(date).tz('America/New_York').format('hh:mm A DD MMM YYYY');
        },
        requestNew() {
            window.axios.post('/admin/driver/' + this.id + '/request-new')
                .then(() => {
                    Swal.fire({
                        icon: 'success',
                        title: 'New driver license successfully requested'
                    });
                });
        },
        approve() {
            window.axios.post('/admin/driver/' + this.id + '/approve')
                .then(() => {
                    this.driver.driverLicense.isApproved = true;
                    Swal.fire({
                        icon: 'success',
                        title: 'Approved',
                        text: 'Start background checkr check?',
                        showCancelButton: true,
                        confirmButtonText: 'Yes'
                    }).then((result) => {
                        if (result.value) {
                            this.initiateCheck();
                        }
                    });
                });
        },
        disapprove() {
            window.axios.post('/admin/driver/' + this.id + '/disapprove')
                .then(() => {
                    this.driver.driverLicense.isApproved = false;
                    Swal.fire({
                        icon: 'success',
                        title: 'Disapproved'
                    });
                });
        },
        initiateCheck() {
            let loader = this.$loading.show();
            window.axios.post('/admin/driver/' + this.id + '/initiate-checkr')
                .then(() => {
                    Swal.fire({
                        icon: 'success',
                        text: 'Background check requested'
                    });
                    setTimeout(() => {
                        this.getData();
                    }, 1000);
                })
                .finally(() => {
                    loader.hide();
                });
        },
        getData() {
            window.axios.get('/admin/driver/' + this.id + '/view')
                .then(response => {
                        this.driver = response.data.driver;
                        this.actions = response.data.actions;
                        this.states = response.data.states;
                    }
                );
        }
    },
    computed: {
        showStartCheckr() {
            return this.driver.driverLicense.isApproved && (!this.driver.checkr || !this.driver.checkr.reportId);
        }
    },
    mounted() {
        this.getData();
    }
}
</script>